<template>
  <div class="content">
    <BlockUI
      v-if="blockScreen"
      :message="blockScreenData.msg"
      :url="blockScreenData.url"
    />

    <v-card>
      <v-card-title>
        <TitleWithButton
          title="Garagens"
          buttonText="Nova garagem"
          :buttonFunction="modalCadastroGarage"
        />
      </v-card-title>

      <v-card-subtitle>
        <v-flex class="mt-2">
          <v-row justify="space-between">
            <v-flex xs12 md6 sm6>
              <v-col align="start">
                <v-text-field
                  v-model="search"
                  prepend-icon="search"
                  label="Procurar"
                  single-line
                  hide-details
                />
              </v-col>
            </v-flex>

            <v-flex xs12 md3 sm6>
              <v-col align="center">
                <download-excel
                  :data="garagesGrid"
                  :fields="json_fields"
                  name="garagens.xls"
                >
                  <v-btn
                    :disabled="garagesGrid.length > 0 ? false : true"
                    block
                    color="success"
                    class="mt-4 white--text"
                  >
                    Exportar
                    <v-icon right>mdi-file-excel</v-icon>
                  </v-btn>
                </download-excel>
              </v-col>
            </v-flex>
          </v-row>
        </v-flex>
      </v-card-subtitle>

      <v-divider />

      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="garagesGrid"
          :search="search"
          class="elevation-1"
          :footer-props="{
            'items-per-page-text': 'Linhas por página:',
          }"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td>{{ item.client.name }}</td>
              <td class>{{ item.address.zip }}</td>
              <!-- <td class>{{ item.description }}</td> -->
              <td class>{{ item.address.address_formatted }}</td>
              <td class>{{ item.address.rotation_id ? 'Sim' : 'Não' }}</td>
              <td class>
                <ActionButton
                  message="Editar garagem"
                  icon="edit"
                  @onclick="editItem(item)"
                />
                <ActionButton
                  message="Excluir garagem"
                  icon="delete"
                  color="error"
                  @onclick="deleteItem(item)"
                />
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <template>
      <v-layout row justify-center>
        <v-dialog
          v-model="register_garage_type_modal"
          persistent
          max-width="600px"
        >
          <v-card>
            <v-card-title>
              <span class="headline">{{
                this.Garage.id ? 'Editar garagem' : 'Nova garagem'
              }}</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex sm12>
                    <v-text-field
                      v-model="Garage.description"
                      label="Descrição:"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex sm12>
                    <v-select
                      v-model="Garage.client_id"
                      :items="clients"
                      item-text="name"
                      item-value="id"
                      label="Cliente:"
                      required
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm12>
                    <label>Endereço</label>
                    <vue-google-autocomplete
                      id="origemAddress"
                      class="form-control"
                      placeholder="Informe o endereço da garagem"
                      country="br"
                      v-model="Garage.address.address_formatted"
                      v-on:placechanged="setAddress"
                    ></vue-google-autocomplete>
                  </v-flex>
                  <v-flex xs12 sm12>
                    <v-select
                      :items="rotation"
                      item-value="value"
                      item-text="text"
                      v-model="Garage.address.rotation_id"
                      label="Rodízio de Placas"
                      required
                    ></v-select>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                flat
                @click="register_garage_type_modal = false"
                >Cancelar</v-btn
              >
              <v-btn color="blue darken-1" flat @click="save()">Salvar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </template>
  </div>
</template>

<script>
import GarageController from '../../controllers/GarageController.js';
import LicensePlateRotationSchemeController from '../../controllers/LicensePlateRotationSchemeController.js';
import ClientController from '../../controllers/ClientController.js';
import Garage from '../../models/Garage.js';
import { blockScreenUi } from '../../helpers/BlockScreenUi';
import ActionButton from '../shared/ActionButtonsTemplate';
import VueGoogleAutocomplete from 'vue-google-autocomplete';
import TitleWithButton from '../../UIComponents/titleWithButton.vue';

export default {
  components: {
    VueGoogleAutocomplete,
    ActionButton,
    TitleWithButton,
  },

  created() {
    this.clientController = new ClientController(this.$resource);
    this.garageController = new GarageController(this.$resource);
    this.licensePlateRotationSchemeController = new LicensePlateRotationSchemeController(
      this.$resource
    );
    this.getLicensePlateRotationSchemes();
    this.getClients();
    this.getGarages();
  },

  data() {
    return {
      blockScreenData: blockScreenUi.blockScreenData,
      blockScreen: false,
      Garage: new Garage(),
      garagesGrid: [],
      search: '',
      json_fields: {
        Cliente: 'client.name',
        Descrição: 'description',
        Endereço: 'address_street',
        Rodízio: 'garage.address.rotation_id',
      },
      headers: [
        { text: 'Cliente', value: 'client.name' },
        { text: 'CEP', value: 'address.zip' },
        // { text: 'Descrição', value: 'description' },
        { text: 'Endereço completo', value: 'address_street' },
        { text: 'Rodízio de placas', value: 'garage.address.rotation_id' },
        { text: 'Ações', value: 'action', sortable: false },
      ],
      clients: [],
      rotation: [
        {
          text: 'Sem rodízio',
          value: null,
        },
      ],
      register_garage_type_modal: false,
    };
  },
  methods: {
    setAddress(addressData, placeResultData, id) {
      let city = placeResultData.address_components.filter(cp => {
        let type = cp.types.filter(
          type => type === 'administrative_area_level_2'
        );
        if (type.length) return cp;
      });
      city = city[0].long_name;

      this.Garage.address.address_formatted = placeResultData.formatted_address;
      this.Garage.address.latitude = addressData.latitude;
      this.Garage.address.longitude = addressData.longitude;
      this.Garage.address.zip = addressData.postal_code
        ? addressData.postal_code.replace('-', '')
        : null;
      this.Garage.address.state = addressData.administrative_area_level_1;
      this.Garage.address.street = addressData.route;
      this.Garage.address.number = addressData.street_number;
      this.Garage.address.neighborhood = placeResultData.vicinity;
      this.Garage.address.city = city;
    },

    editItem(item) {
      this.Garage = Object.assign({}, item);
      this.register_garage_type_modal = true;
    },

    deleteItem(item) {
      this.Garage = Object.assign({}, item);
      this.deleteGarage();
    },

    getLicensePlateRotationSchemes() {
      this.licensePlateRotationSchemeController
        .getAll()
        .then(res => {
          res = res.map(scheme => ({
            text: `${scheme.state}, ${scheme.city}`,
            value: scheme.id,
          }));
          this.rotation = [...this.rotation, ...res];
        })
        .catch(error => {
          console.log(error);
        });
    },

    getClients() {
      this.clientController
        .getAllClients()
        .then(clients => (this.clients = clients));
    },

    getGarages() {
      this.blockScreen = true;
      this.garageController.getAllGarages().then(res => {
        this.garagesGrid = res;
        this.blockScreen = false;
      });
    },
    async save() {
      if (this.Garage.id) {
        this.garageController.update(this.Garage).then(
          res => {
            if (!res.OK) {
              this.$awn.success(res.message);
            } else {
              this.$awn.warning(res.message);
            }
            this.getGarages();
          },
          err => {
            this.$awn.alert(err.body.message);
          }
        );
      } else {
        this.garageController.create(this.Garage).then(
          res => {
            if (!res.OK) {
              this.$awn.success(res.message);
            } else {
              this.$awn.warning(res.message);
            }
            this.getGarages();
          },
          error => {
            this.$awn.alert(error.body.message);
          }
        );
      }
      this.register_garage_type_modal = false;
    },
    deleteGarage() {
      swal({
        title: 'Você tem certeza?',
        text: 'Essa ação não poderá ser desfeita!',
        icon: 'error',
        buttons: true,
        dangerMode: true,
      }).then(willDelete => {
        if (willDelete) {
          this.garageController.delete(this.Garage).then(
            res => {
              this.getGarages();
              this.$awn.success('Garagem excluída com sucesso!');
            },
            error => {
              this.$awn.alert(error.body.message);
            }
          );
        }
      });
    },
    modalCadastroGarage() {
      this.register_garage_type_modal = true;
      this.Garage = new Garage();
    },
    handleSelectionChange(val) {
      this.selectedRow = val;
    },
  },
};
</script>
<style lang="scss">
.buttons-action td:last-child div {
  text-align: right;
}
.buttons-action td:last-child div button {
  margin-left: 2px;
  margin-bottom: 2px;
  margin-right: 2px;
}
.buttons-action th:last-of-type div {
  margin-left: 11px;
  text-align: center;
}
.btn-cancel {
  margin-right: 10px !important;
  color: #fff;
  background-color: #ff3939;
  border-color: #ef3f3f;
}
.btn-cancel:hover {
  background: #f78989;
  border-color: #f78989;
  color: #fff;
}
.table-custom-vue {
  margin: 20px;
}
.pac-container {
  z-index: 9999999 !important;
}
.table-custom-vue td:last-child {
  display: flex;
  justify-content: center;
}
.table-custom-vue thead tr > th {
  text-align: center !important;
}

.new-garage-button {
  border: none;
  &:hover {
    color: white;
    background: var(--primary-color-hover);
  }
}
</style>
